import moment from "moment";
import { getAge } from "./shared";
export const STANDARD_MINIMUM_VALUE = 0;
export const STANDARD_MAXIMUM_VALUE = 1000000000;
export const MAX_TEXT_SIZE = 255;
export const MIN_TEXT_SIZE = 0;

export const isTextBoxNonEmpty = (text, max_text_size, min_text_size) => {
    if (!max_text_size) max_text_size = MAX_TEXT_SIZE;
    if (!min_text_size) min_text_size = MIN_TEXT_SIZE;
    if (text === null) return false;
    if (text.length > max_text_size) return false;
    if (text.length < min_text_size) return false;
    return text !== "";
};

export const isEmailValid = (email) => {
    if (!isTextBoxNonEmpty(email)) return false;
    let re = /\S+@\S+\.\S+/;
    return re.test(email);
};

export const isPasswordValid = (password, max_text_size) => {
    if (!isTextBoxNonEmpty(password, max_text_size)) return false;
    return password !== "";
};

export const isNumericTextboxValid = (value, minimum, maximum) => {
    if (!minimum) minimum = STANDARD_MINIMUM_VALUE;
    if (!maximum) maximum = STANDARD_MAXIMUM_VALUE;
    if (value === "" || value === null) return false;

    value = parseFloat(value);
    return !(value < minimum || value > maximum);
};

export const isPhoneNumberValid = (phoneNumber) => {
    if(phoneNumber === '___-___-____' || phoneNumber === "") return true;
    var formats = "(999)-999-9999|999-999-9999|9999999999";
    //var formats = "999-999-9999";
    var r = RegExp("^(" +
        formats
            .replace(/([\(\)])/g, "\\$1")
            .replace(/9/g,"\\d") +
        ")$");
    return r.test(phoneNumber);
};

export const isPhoneNumberValidandNotEmpty = (phoneNumber) => {
    var formats = "(999)-999-9999|999-999-9999|9999999999";
    //var formats = "999-999-9999";
    var r = RegExp("^(" +
        formats
            .replace(/([\(\)])/g, "\\$1")
            .replace(/9/g,"\\d") +
        ")$");
    return r.test(phoneNumber);
};

export const isValidCreditCardExpiratoryDate = (value) => {
    if (value === "" || value === null || value == "__/__") return false;
    const exMonth = parseInt(value.substring(0, 2));
    if(exMonth === 0 || exMonth > 12) return false;
    const exYear = parseInt("20" + value.substring(3));
    const today = new Date();
    let someday = new Date();
    someday.setFullYear(exYear, exMonth, 0);

    if (someday < today) {
        return false;
    }else {
        return true;
    }
};

export const formObjectValidator = (formObj) => {
    for (let prop in formObj) {
        if (!formObj.hasOwnProperty(prop)) continue;
        if (!formObj[prop].isValid) return false;
    }
    return true;
};

export const validateBillingInformation = (billingInformation) => {
    return {
        firstName: {
            value: billingInformation.firstName.value,
            isValid: isTextBoxNonEmpty(billingInformation.firstName.value)
        },
        lastName: {
            value: billingInformation.lastName.value,
            isValid: isTextBoxNonEmpty(billingInformation.lastName.value)
        },
        address: {
            value: billingInformation.address.value,
            isValid: isTextBoxNonEmpty(billingInformation.address.value)
        },
        city: {
            value: billingInformation.city.value,
            isValid: isTextBoxNonEmpty(billingInformation.city.value)
        },
        state: {
            value: billingInformation.state.value,
            isValid: isTextBoxNonEmpty(billingInformation.state.value)
        },
        zipCode: {
            value: billingInformation.zipCode.value,
            isValid: billingInformation.zipCode.value.replace(/_/g, '').length == 5
        },
        email: {
            value: billingInformation.email.value,
            isValid: isEmailValid(billingInformation.email.value)
        },
        phone: {
            value: billingInformation.phone.value,
            isValid: isPhoneNumberValidandNotEmpty(billingInformation.phone.value)
        }
    };
};

export const validateCreditCardInformation = (creditCardInformation) => {
    return  {
        creditCardType: {
            value: creditCardInformation.creditCardType.value,
            isValid: isTextBoxNonEmpty(creditCardInformation.creditCardType.value)
        },
        creditCardNumber: {
            value: creditCardInformation.creditCardNumber.value,
            isValid: isCreditCardNumberValid(creditCardInformation.creditCardNumber.value, creditCardInformation.creditCardType.value)
        },
        expiratoryDate: {
            value: creditCardInformation.expiratoryDate.value,
            isValid: isValidCreditCardExpiratoryDate(creditCardInformation.expiratoryDate.value)
        },
        cvv: {
            value: creditCardInformation.cvv.value,
            isValid: isCvvValid(creditCardInformation.cvv.value, creditCardInformation.creditCardType.value)
        }
    }
};

export const limitCharacters = (input, characterLimit) => {
    if (input.length > characterLimit) return input.substr(0, characterLimit);
    return input;
};

export const validateFeeModel = (feeModel) => {
    return  {
        feeModelName: {
            value: feeModel.feeModelName.value,
            isValid: isTextBoxNonEmpty(feeModel.feeModelName.value)
        },
        reduceReturn: {
            value: feeModel.reduceReturn.value,
            isValid: true
        },
        blendedRate: {
            value: feeModel.blendedRate.value,
            isValid: isNumericTextboxValid(feeModel.blendedRate.value, 0, 1)
        },
        minimumAmount: {
            value: feeModel.minimumAmount.value,
            isValid: isNumericTextboxValid(feeModel.minimumAmount.value, 0)
        },
        flatFee: {
            value: feeModel.flatFee.value,
            isValid: isNumericTextboxValid(feeModel.flatFee.value, 0)
        }
    }
};

export const validateClientAndCoClient = (data) => {

    const logicalValidationLifeExpectancy = () => {
        let dob = moment(data.dateOfBirth.value);
        let age = moment().diff(dob,'years');
        if (!isNumericTextboxValid(data.lifeExpectancy.value, 0, 200)) {
            return false;
        } else if ((age > data.lifeExpectancy.value) || (data.lifeExpectancy.value > 200)) {
            console.log("Life expectancy lesser than age upi= age=>" + age + " life expect= " + dob);
            return false;
        } else {
            return true;
        }
    };

    const logicalValidationRetirementAge = () => {
        let dob = moment(data.dateOfBirth.value);
        if (!isNumericTextboxValid(data.retirementAge.value, 0, 200)) {
            return false;
        } else if ((data.retirementAge.value > data.lifeExpectancy.value) || (data.retirementAge.value > 200)) {
            console.log("Life expectancy lesser than retirement age upi=retire=>" + data.retirementAge.value + " life= " + data.lifeExpectancy.value);
            return false;
        } else {
            return true;
        }
    };

    return {
        ...data,
        firstName: {
            value: data.firstName.value,
            isValid: isTextBoxNonEmpty(data.firstName.value, 30)
        },
        lastName: {
            value: data.lastName.value,
            isValid: isTextBoxNonEmpty(data.lastName.value, 30)
        },
        retirementAge: {
            value: data.retirementAge.value,
            isValid: logicalValidationRetirementAge() //isNumericTextboxValid(data.retirementAge.value, 0, 100)
        },
        lifeExpectancy: {
            value: data.lifeExpectancy.value,
            isValid: logicalValidationLifeExpectancy() //isNumericTextboxValid(data.lifeExpectancy.value, 0, 100)
        }
    }
};

export const isCreditCardNumberValid = (number, type)=>{
    const length = number.replace(/-/g, '').replace(/_/g, '').length
    return (length==15&&type=="American Express" || length == 16)
  }
  
export  const isExpDateValid = (value) =>{
    const regex = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/;
    return (regex.test(value))
}
  
export  const isCvvValid = (value, type)=>{
    const length = value.replace(/_/g, '').length;
    return ((length==4&&type=="American Express") || length == 3&&type!="American Express")
}

export const feCreditCardNumberValidation = (value, type) => {
    if (value.startsWith("XXXX")) return true;
    if (value != "") {
        if(type.toUpperCase()=="VISA" && value[0]=="4") return true
        else if(type.toUpperCase()=="MASTERCARD" && (value[0]=="5" || value[0]=="2")) return true
        else if(type.toUpperCase()=="AMERICAN EXPRESS" && value[0]=="3" && (value[1]=="4" || value[1]=="7")) return true
        else if(type.toUpperCase()=="DISCOVER" && value[0]=="6") return true
        else return false
    }
    return false
}

export const isDatePriorToTodaysMonth = date=>{
    const d = new Date()
    const today = new Date(d.getFullYear(), d.getMonth(), 1, 0, 0, 0, 0);
    return (date < today)
}

export const isDateFurtherThanLifeExpectancy = (date, dateOfBirth, lifeExpectancy)=>{
    const d = new Date()
    const currentAge = getAge(dateOfBirth)
    const yearsAhead = lifeExpectancy - currentAge
    const dOB = new Date(dateOfBirth)
    const extraYearWithSameAge = dOB.getMonth()===0?0:1
    const limitMonth = dOB.getMonth()===0?11:d.getMonth()-1
    const limitDate = new Date(d.getFullYear() + yearsAhead + extraYearWithSameAge, limitMonth, 1, 0, 0, 0, 0);
    const inputDate = new Date(date)
    return (inputDate > limitDate)
}